import { createContext, useContext, useState, useEffect } from 'react';

// Translations object
const translations = {
  he: {
    // Navigation
    nav_about: 'אודות',
    nav_method: 'שיטת סאטיה',
    nav_services: 'שירותים',
    nav_contact: 'צור קשר',
    nav_book: 'קביעת שיחה',
    
    // Hero Section
    hero_title: 'המסע להיכרות עצמית,',
    hero_title_span: 'מתחיל. כאן.',
    hero_subtitle: 'אימון בשיטת סאטיה: מסע של חופש פנימי, שחרור מדפוסים אוטומטיים והתעוררות אל השקט שבפנים.',
    hero_cta: 'לשיחת היכרות',
    hero_cta_secondary: 'קראו עוד',
    
    // Welcome Banner
    welcome_title: 'ברוכים הבאים למרחב שלי',
    welcome_message: 'לוקח אומץ לצאת למסע של גילוי עצמי ולהתקרב לעצמך. אני מכבד את הצעד הזה.',
    
    // Pain Section
    pain_title: 'מכירים את זה ש..?',
    pain_item1: 'מרגיש שמשהו "תקוע"? שהקול הביקורתי בראש לא נותן לך מנוח?',
    pain_item2: 'מוצא את עצמך מגיב באותן דרכים אוטומטיות שוב ושוב?',
    pain_item3: 'יודע שזה פוגע בך וביחסים שלך, אבל לא מצליח לשנות?',
    pain_quote: 'אנחנו אלופים בללכת מסביב, בלהתעלם מהכאב, בלטאטא מתחת לשטיח. עד שמגיע הרגע שבו מבינים ש... די.',
    pain_insight: 'להמשיך להימנע רק יעצים את האחיזה של הסבל. הדרך היחידה להשתחרר היא להכיר אותו.',
    
    // Satya Method Section
    satya_title: 'מהו אימון בשיטת סאטיה?',
    satya_intro: 'אימון סאטיה הוא מפגש כנה עם עצמך, המזמין להקשיב לגוף ולתת מקום לרגשות כפי שהם, ללא ניסיון לשינוי בכוח. דרך פיתוח חמלה וסקרנות פנימית, אנו משנים את היחסים עם העבר ומשתחררים מדפוסים אוטומטיים. זהו תהליך של טרנספורמציה שבו הסכמה לפגוש את הכאב מולידה בהירות, אחריות אישית וחופש בחירה חדש.',
    satya_suffering: 'במהלך האימון אתה מפתח הבחנה בין נסיבות החיים לבין מי שאתה. נוצר מרחב שבו אפשר להתבונן בסיפור האישי מבלי להיאחז בו. מתוך המקום הזה מתפתחת סליחה עצמית, לצד חמלה כלפי עצמך.',
    satya_past: 'העבר מקבל הכרה וכבוד. לא משנים את מה שקרה, אלא את היחסים שלך עם מה שקרה. אתה לומד להיות פעיל מול החוויה שלך, במקום להגיב מתוך דפוסים אוטומטיים.',
    satya_curiosity: 'בתהליך מתפתחת סקרנות פנימית. אתה פוגש את הילד הפנימי שלך, לומד להבין אותו ולשאת אחריות כלפיו. חלקים שונים בתוכך מתחברים, ונוצרת הבנה עמוקה יותר למקור התגובות, הרגשות והבחירות שלך.',
    satya_approach: 'הסבל הוא חלק מהקיום האנושי. בשיטת סאטיה עובדים כדי להפחית אותו. לא דרך הימנעות, אלא דרך מפגש ישיר.',
    satya_philosophy: 'הדגש אינו על מטרה חיצונית, אלא על החוויה שלך מול המציאות. כאשר אתה מסכים להרגיש, גם כאב ואי נוחות מקבלים מקום. דרך ההכרה נוצר שינוי, ומתאפשר שחרור.',
    satya_benefit1_title: 'לזהות את האמת',
    satya_benefit1_desc: 'ליצור בהירות פנימית מתוך הכרת התחושות והרגשות המנהלים אותנו.',
    satya_benefit2_title: 'להשתחרר מהאוטומט',
    satya_benefit2_desc: 'להרחיב את המרווח שבין הטריגר לתגובה, ולפתח חמלה עצמית.',
    satya_benefit3_title: 'לחיות מתוך בחירה',
    satya_benefit3_desc: 'להחליף את האשמה באחריות אישית מלאה, ולחיות מתוך כנות ודיוק.',
    satya_benefit4_title: 'מערכות יחסים טובות יותר',
    satya_benefit4_desc: 'קודם כל, מערכת יחסים בריאה ומטיבה עם עצמך.',
    satya_quote: '״אנשים יעשו דברים נוראיים ויהרסו יחסים רק כדי להדוף את מה שעובר עליהם גופנית״',
    satya_quote_author: '- נטאלי בן דוד, מייסדת שיטת סאטיה',
    
    // About Section
    about_title: 'נעים מאוד, אני ערן.',
    about_p1: 'מאמן בשיטת סאטיה, בעל תואר שני (MBA) במינהל עסקים ופסיכולוגיה ארגונית, פילותרפיסט ואח תאום.',
    about_p2: 'המסע שלי התחיל הרבה לפני הקליניקה. כגבר שגדל כאח תאום, חוויתי מגיל צעיר את משקל ההשוואתיות. במשך שנים ליוותה אותי תחושת "לא מספיק" צורבת וצורך תמידי להשתנות ולהתאים את עצמי לסביבה כדי להתקבל.',
    about_p3: 'במשך שנים פעלתי בעולמות הפרסום וההיי-טק, ותמיד מצאתי את עצמי באופן טבעי בתפקידים המצריכים הבנה עמוקה של האנשים סביבי. אך בעוד שהבנתי אחרים, המרחק מעצמי רק גדל. לפני כמעט עשור, בתוך משבר זהות ותקופה של אי-בהירות עמוקה, פגשתי לראשונה את שיטת סאטיה כמתאמן. שם גיליתי שהטרנספורמציה האמיתית אינה דורשת ממני "להשתנות" כדי לרצות את העולם, אלא להסכים להכיר את מי שאני.',
    about_p4: 'הכלים והחופש שגיליתי בסאטיה ליוו אותי גם לפני 6 שנים, כשעשיתי את הרילוקיישן לספרד – צעד שדרש ממני נוכחות ודיוק פנימי חדש.',
    about_p5: 'היום, אני מלווה אנשים בתהליכי התעוררות ושחרור מהדפוסים והאוטומטים שאימצו לעצמם. אני מזמין אתכם להפסיק לנסות "להתאים" את עצמכם לסביבה, ולהתחיל לשוב הביתה – אל עצמכם.',
    about_location: 'המפגשים נערכים אונליין (Zoom/Google Meet) או במרכז מדריד.',
    
    // Services Section
    services_title: 'השירותים שלי',
    service1_title: 'תהליך אימון מעמיק',
    service1_desc: 'סדרת מפגשים שבועיים לתהליך טרנספורמטיבי אישי ועמוק בו נתבונן בחייך דרך הגוף, השפה וההוויה.',
    service1_detail: 'אונליין או פרונטלי | עברית/אנגלית',
    service2_title: 'שיחת הכנה - Clearway',
    service2_desc: 'יש לך שיחה משמעותית שאתה נמנע ממנה? ראיון עבודה? שיחת שכר? בפגישה נכין יחד את הקרקע ונתרגל.',
    service2_detail: '60-90 דקות | מומלץ עד יומיים לפני האירוע',
    services_cta: 'לפרטים נוספים',
    
    // Contact Form
    contact_title: 'השאירו פרטים',
    contact_subtitle: 'ואחזור אליכם לשיחת היכרות קצרה',
    form_name: 'שם מלא',
    form_country: 'מדינה',
    form_phone: 'טלפון',
    form_email: 'אימייל (אופציונלי)',
    form_best_time: 'מתי הכי נוח לחזור אליך?',
    form_morning: 'בוקר',
    form_noon: 'צהריים',
    form_evening: 'ערב',
    form_message: 'ספרו לי קצת על עצמכם (אופציונלי)',
    form_submit: 'שליחה',
    form_success: 'הפרטים נשלחו בהצלחה! אחזור אליך בהקדם.',
    form_error: 'אירעה שגיאה, אנא נסו שוב.',
    
    // Book Call Banner
    book_title: 'מוזמנים לשיחת היכרות',
    book_subtitle: 'בשיחה קצרה נבדוק יחד אם האימון מתאים לך',
    book_cta: 'קביעת שיחה',
    
    // Footer
    footer_follow: 'עקבו אחרי',
    footer_contact: 'צרו קשר',
    footer_rights: 'כל הזכויות שמורות',
    
    // Cookie Banner
    cookie_title: 'אנחנו משתמשים בעוגיות',
    cookie_message: 'האתר משתמש בעוגיות כדי לשפר את החוויה שלך. תוכל לבחור אילו עוגיות לאשר.',
    cookie_accept_all: 'אשר הכל',
    cookie_customize: 'התאמה אישית',
    cookie_reject: 'דחה',
    cookie_marketing: 'עוגיות שיווקיות',
    cookie_analytics: 'עוגיות אנליטיקה',
    cookie_necessary: 'עוגיות הכרחיות',
    cookie_necessary_desc: 'נדרשות לתפקוד האתר',
    cookie_analytics_desc: 'עוזרות לנו לשפר את האתר',
    cookie_marketing_desc: 'תוכן ופרסום מותאם אישית',
    cookie_save: 'שמור העדפות',
  },
  en: {
    // Navigation
    nav_about: 'About',
    nav_method: 'Satya Method',
    nav_services: 'Services',
    nav_contact: 'Contact',
    nav_book: 'Book a Call',
    
    // Hero Section
    hero_title: 'The journey to self-discovery',
    hero_title_span: 'begins. Here.',
    hero_subtitle: 'Satya Coaching: A journey of inner freedom, releasing automatic patterns, and awakening to the stillness within.',
    hero_cta: 'Book an Intro Call',
    hero_cta_secondary: 'Learn More',
    
    // Welcome Banner
    welcome_title: 'Welcome to My Space',
    welcome_message: 'It takes courage to embark on a journey of self-discovery and come closer to yourself. I honor this step.',
    
    // Pain Section
    pain_title: 'Do you know that feeling..?',
    pain_item1: 'Feeling "stuck"? The critical voice in your head won\'t give you peace?',
    pain_item2: 'Finding yourself reacting in the same automatic ways, again and again?',
    pain_item3: 'Knowing it hurts you and your relationships, but can\'t seem to change?',
    pain_quote: 'We\'re experts at going around, ignoring the pain, sweeping it under the rug. Until that moment when we realize... enough.',
    pain_insight: 'Continuing to avoid will only strengthen suffering\'s grip. The only way to freedom is to know it.',
    
    // Satya Method Section
    satya_title: 'What is Satya Coaching?',
    satya_intro: 'Satya coaching is an honest encounter with yourself, inviting you to listen to the body and give space to emotions as they are, without attempting to change by force. Through developing compassion and inner curiosity, we change our relationship with the past and free ourselves from automatic patterns. It is a process of transformation where agreeing to meet pain gives birth to clarity, personal responsibility, and new freedom of choice.',
    satya_suffering: 'During coaching, you develop the ability to distinguish between life circumstances and who you are. A space is created where you can observe your personal story without clinging to it. From this place, self-forgiveness develops, alongside compassion toward yourself.',
    satya_past: 'The past receives recognition and respect. You don\'t change what happened, but your relationship with what happened. You learn to be active in the face of your experience, instead of reacting from automatic patterns.',
    satya_curiosity: 'In the process, inner curiosity develops. You meet your inner child, learn to understand them and take responsibility toward them. Different parts within you connect, and a deeper understanding of the source of your reactions, emotions, and choices is formed.',
    satya_approach: 'Suffering is part of human existence. In the Satya method, we work to reduce it. Not through avoidance, but through direct encounter.',
    satya_philosophy: 'The emphasis is not on an external goal, but on your experience in the face of reality. When you agree to feel, even pain and discomfort receive space. Through recognition, change is created, and release becomes possible.',
    satya_benefit1_title: 'Identify Your Truth',
    satya_benefit1_desc: 'Create inner clarity by recognizing the sensations and emotions that drive us.',
    satya_benefit2_title: 'Break Free from Autopilot',
    satya_benefit2_desc: 'Expand the space between trigger and response, developing self-compassion.',
    satya_benefit3_title: 'Live by Choice',
    satya_benefit3_desc: 'Replace blame with full personal responsibility, living with honesty and precision.',
    satya_benefit4_title: 'Better Relationships',
    satya_benefit4_desc: 'Starting with a healthy, nurturing relationship with yourself.',
    satya_quote: '"People will do terrible things and destroy relationships just to fend off what they are experiencing physically"',
    satya_quote_author: '- Natali Ben David, Founder of the Satya Method',
    
    // About Section
    about_title: 'Nice to meet you, I\'m Eran.',
    about_p1: 'A Satya method coach, holding an MBA in Business Administration and Organizational Psychology, a philotherapist, and a twin brother.',
    about_p2: 'My journey began long before the clinic. As a man who grew up as a twin, I experienced the weight of comparison from a young age. For years I was accompanied by a burning feeling of "not enough" and a constant need to change and adapt myself to fit in and be accepted.',
    about_p3: 'For years I worked in advertising and high-tech, always naturally finding myself in roles requiring deep understanding of the people around me. But while I understood others, the distance from myself only grew. Almost a decade ago, in the midst of an identity crisis and a period of deep uncertainty, I first encountered the Satya method as a coachee. There I discovered that true transformation doesn\'t require me to "change" to please the world, but to agree to know who I am.',
    about_p4: 'The tools and freedom I discovered in Satya also accompanied me 6 years ago, when I relocated to Spain – a step that demanded new presence and inner precision.',
    about_p5: 'Today, I guide people through processes of awakening and releasing the patterns and automatic behaviors they\'ve adopted. I invite you to stop trying to "fit" yourselves to your surroundings, and to start coming home – to yourselves.',
    about_location: 'Sessions are held online (Zoom/Google Meet) or in central Madrid.',
    
    // Services Section
    services_title: 'My Services',
    service1_title: 'In-Depth Coaching Process',
    service1_desc: 'A series of weekly sessions for a deep personal transformative process where we observe your life through body, language, and being.',
    service1_detail: 'Online or in-person | Hebrew/English',
    service2_title: 'Prep Call - Clearway',
    service2_desc: 'Have an important conversation you\'ve been avoiding? Job interview? Salary negotiation? Together we\'ll prepare and practice.',
    service2_detail: '60-90 minutes | Recommended up to 2 days before the event',
    services_cta: 'Learn More',
    
    // Contact Form
    contact_title: 'Leave Your Details',
    contact_subtitle: 'I\'ll get back to you for a short introductory call',
    form_name: 'Full Name',
    form_country: 'Country',
    form_phone: 'Phone',
    form_email: 'Email (optional)',
    form_best_time: 'Best time to contact you?',
    form_morning: 'Morning',
    form_noon: 'Noon',
    form_evening: 'Evening',
    form_message: 'Tell me a bit about yourself (optional)',
    form_submit: 'Submit',
    form_success: 'Details sent successfully! I\'ll be in touch soon.',
    form_error: 'An error occurred, please try again.',
    
    // Book Call Banner
    book_title: 'Schedule an Intro Call',
    book_subtitle: 'A short conversation to see if coaching is right for you',
    book_cta: 'Book Now',
    
    // Footer
    footer_follow: 'Follow Me',
    footer_contact: 'Get in Touch',
    footer_rights: 'All rights reserved',
    
    // Cookie Banner
    cookie_title: 'We use cookies',
    cookie_message: 'This site uses cookies to improve your experience. You can choose which cookies to accept.',
    cookie_accept_all: 'Accept All',
    cookie_customize: 'Customize',
    cookie_reject: 'Reject',
    cookie_marketing: 'Marketing cookies',
    cookie_analytics: 'Analytics cookies',
    cookie_necessary: 'Necessary cookies',
    cookie_necessary_desc: 'Required for the website to function',
    cookie_analytics_desc: 'Help us improve our website',
    cookie_marketing_desc: 'Personalized content and ads',
    cookie_save: 'Save Preferences',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('he');
  const [direction, setDirection] = useState('rtl');

  useEffect(() => {
    document.documentElement.setAttribute('dir', direction);
    document.documentElement.setAttribute('lang', language);
  }, [direction, language]);

  const toggleLanguage = () => {
    const newLang = language === 'he' ? 'en' : 'he';
    setLanguage(newLang);
    setDirection(newLang === 'he' ? 'rtl' : 'ltr');
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, direction, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
